













































































































































































































































































































































import { Entreprise } from "@/api/models/adherents/adherent";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { StatusEnum } from "@/api/models/enums/statusEnum";
import { TypeContratEnum } from "@/api/models/enums/typeContratEnum";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BDropdownItem,
  BFormInput,
  BFormCheckbox,
  BPagination,
  BRow,
  BTable,
  BBadge,
  BAlert,
  BFormDatepicker,
  BFormGroup
} from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import CreateAdherent from "./Create.vue";
import { InformationOperationnelle, InformationOperationnelleCle } from "@/api/models/informationsOperationnelles/informationOperationnelle";

@Component({
  components: {
    BCard,
    BAlert,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormCheckbox,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    CreateAdherent,
    BFormSelect,
    BBadge,
    SearchableVueSelect,
    BFormDatepicker,
    BFormGroup
  },
})
export default class ListAdherents extends Vue {
  statusOptions = Object.entries(StatusEnum).map(([key, value]) => ({
    label: value,
    value: key
  }));
  status = StatusEnum
  typesContrat = TypeContratEnum
  perPage = 25;
  pertinentOnly = false;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  timeout: any = null;
  searchQuery = "";
  isSortDirDesc = false;
  sortBy = "libelle";
  isAddNewAdherentSidebarActive = false;
  sortStatuts: any = [
    this.statusOptions.find(x => x.label == StatusEnum.ADHERENT)?.value,
    this.statusOptions.find(x => x.label == StatusEnum.MISSIONSPONCTUELLES)?.value,
    this.statusOptions.find(x => x.label == StatusEnum.PROSPECT)?.value,
  ]
  sortStatutsOld: any = null
  listInformationsOperationnelles: InformationOperationnelleCle[] = []
  sortInformationOperationnelle: any = null
  searchInformationOperationnelle: any = null
  searchInformationOperationnelleMax: any = null
  listInfoChoice: any = null

  tableColumns = [
    { key: "status", label: "statut", sortable: false },
    { key: "libelle", sortable: true },
    { key: "siret", sortable: true },
    { key: "adresse", sortable: true },
    { key: "ville", sortable: true },
    { key: "codePostal", sortable: true },
    { key: "pertinentLabel", sortable: true, label : "Pertinent" }
  ];
  paginatedListAdherents = new PaginatedList<Entreprise>();

  get inputTypeInformationOperationnelle() {
    const found = this.listInformationsOperationnelles.find(item => item.key === this.sortInformationOperationnelle);
    return found ? found.inputType : null;
  }

  get typeKeyInformationOperationnelle() {
    const found = this.listInformationsOperationnelles.find(item => item.key === this.sortInformationOperationnelle);
    return found ? found.typeKey : null;
  }

  get isBudgetInformationOperationnelle() {
    const found = this.listInformationsOperationnelles.find(item => item.key === this.sortInformationOperationnelle);
    return found ? found.isBudget : null;
  }


  get userPreferences() {
    return this.$store.state.user.user_preferences
  }
  get preference() {
    return this.userPreferences.find((value: any) => {
      return value.key == 'adherentsColumns'
    });
  }

  async created() {
    if(this.userPreferences){
      var columnsPreferences = this.preference;
      
      if(columnsPreferences){
      console.log(JSON.parse(columnsPreferences.value));

        if(JSON.parse(columnsPreferences.value).length > 0){
          this.tableColumns = [...JSON.parse(columnsPreferences.value)];
        } else {
          this.tableColumns = this.tableColumns;
        }
      }  
    }

    await this.loadListAdherents({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery,
      pertinentOnly: this.pertinentOnly,
      sortStatuts: this.sortStatuts
    });

    await this.loadListInformationsOperationnelles()
  }

  @Watch("sortInformationOperationnelle")
  async getInfosOperationnelles() {
    if (this.inputTypeInformationOperationnelle != 'List') return
    await this.$http.myressif.parametres
      .getByNom(this.typeKeyInformationOperationnelle)
      .then(async (res: InformationOperationnelle) => {
        try {
          let x = res.nom;
          console.log('begin for', res.nom)
          this.listInfoChoice = res ? 
            //@ts-ignore
            JSON.parse(res.valeur)?.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            }) : [];
        }
        catch(ex: any) {
          console.log('ici', ex)
        }
      }),
      (error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      };
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListAdherents.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListAdherents.items.length
    );
  }

  @Watch("currentPage")
  @Watch("perPage")
  @Watch("pertinentOnly")
  async paginationChanged() {
    await this.loadListAdherents({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery,
      pertinentOnly: this.pertinentOnly,
      sortStatuts: this.sortStatuts
    });
  }

  @Watch('searchQuery')
  async searchQueryChanged() {
    if (this.searchQuery.length > 0) {
      this.sortStatutsOld = this.sortStatuts
      this.sortStatuts = []
    } else if (this.sortStatutsOld != null) {
      this.sortStatuts = this.sortStatutsOld
      this.sortStatutsOld = null
    }
    this.paginationChanged()
  }

  @Watch("sortBy")
  @Watch("isSortDirDesc")
  @Watch("pertinentOnly")
  @Watch("sortStatuts")
  @Watch("searchInformationOperationnelle")
  @Watch("searchInformationOperationnelleMax")
  async searchAdherent() {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListAdherents({
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        orderBy: this.sortBy,
        orderByDescending: this.isSortDirDesc,
        search: this.searchQuery,
        pertinentOnly: this.pertinentOnly,
        sortStatuts: this.sortStatuts,
        sortInformationOperationnelleKey: this.sortInformationOperationnelle,
        sortInformationOperationnelleSearch: this.searchInformationOperationnelle,
        sortInformationOperationnelleSearchMax: this.searchInformationOperationnelleMax,
        sortInformationOperationnelleInputType: this.inputTypeInformationOperationnelle,
        isBudgetInformationOperationnelle: this.isBudgetInformationOperationnelle
      })
    }, 1000);
  }

  updateSort(params: any) {
    this.sortBy = params.sortBy;
    params = {
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      orderBy: this.sortBy,
      orderByDescending: this.isSortDirDesc,
      pertinentOnly: this.pertinentOnly,
      sortStatuts: this.sortStatuts
    };
    this.isSortDirDesc = !this.isSortDirDesc;
    this.loadListAdherents(params);
  }

  async loadListInformationsOperationnelles() {
    await this.$http.myressif.informationsOperationnelles
      .list()
      .then((response: InformationOperationnelleCle[]) => {
        this.listInformationsOperationnelles = response;
      });
  }

  async loadListAdherents(params: any) {
    if (!params || params?.reset) {
      this.paginatedListAdherents = new PaginatedList<Entreprise>();
    }

    await this.$http.myressif.entreprises
      .paginatedList(
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy,
        params?.orderByDescending,
        params?.search ?? "",
        params?.pertinentOnly,
        null,
        null,
        params?.sortStatuts,
        params?.sortInformationOperationnelleKey,
        params?.sortInformationOperationnelleSearch,
        params?.sortInformationOperationnelleSearchMax,
        params?.sortInformationOperationnelleInputType,
        params?.isBudgetInformationOperationnelle
      )
      .then((response: PaginatedList<Entreprise>) => {
        this.paginatedListAdherents = response;
      });
  }

  async askDeleteAdherent(id: string) {
    this.$bvModal
      .msgBoxConfirm("Etes-vous sûr de vouloir supprimer cet adhérent ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDelete(id);
        } else {
          return;
        }
      });
  }

  async confirmDelete(id: string) {
    await this.$http.myressif.entreprises.delete(id).then(
      async (response: string) => {
        successAlert.fire({
          title: "Suppression d'un adhérent",
          text: "Suppression effectuée avec succès",
        });
        await this.loadListAdherents(null);
      },
      (error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      }
    );
  }

  onRowSelected(record: any) {
    this.$router.push({ name: "details-adherent", params: { id: record.id } });
  }

}
